import { useStore } from '@mirai/data-sources';
import PropTypes from 'prop-types';
import React from 'react';

import { Account } from './Session.Account';
import { Login } from './Session.Login';

const Session = ({ ghost, headless = false, ...others }) => {
  const {
    value: { session, club },
  } = useStore();

  const [ghostLogin, ghostAccount] = ghost?.children || [];

  if (headless) return club && !session ? <Login {...others} ghost={ghostLogin} headless /> : null;

  return club
    ? React.createElement(session ? Account : Login, { ...others, ghost: session ? ghostAccount : ghostLogin })
    : null;
};

Session.displayName = 'Mirai:Core:Session';

Session.propTypes = {
  ghost: PropTypes.any,
  headless: PropTypes.bool,
};

export { Session };
